export default __webpack_public_path__ + "static/media/Violin Shield of the Twelfth Dynasty.b1e1c57b.jpg";